Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-google-widget', function (envelope) {

        var $context = envelope.message.data.context,
        	$wrappers = $('.x-google-widget', $context);

        if ($wrappers.length < 1)
            return;

        var $buttons = $('.js-gsubmit-button', $wrappers);

        if (!Vendd.User.AuthProviders.google)
            throw new Error('google vendd auth provider not found');

        if ($buttons.length > 0) {
            Vendd.User.AuthProviders.google.init();
        }

        $buttons.click(function (e) {
            if (typeof (e.preventDefault) === 'function')
                e.preventDefault();

            Vendd.User.AuthProviders.google.login();
        });

    });
});